// ----------------------------------------------------------------------------
// feature/eu-migration — EU Cognito (prod pool). Only the API URL switches.
// Account 533267136286 / eu-central-1 / profile flexhr_dev.
// Overridable via REACT_APP_* in .env.development / .env.production.
// ----------------------------------------------------------------------------

const env = (key, fallback) => {
  const v = process.env[key];
  return v != null && String(v).trim() !== "" ? String(v).trim() : fallback;
};

// Shared EU Cognito (prod pool) — same for localhost and deployed builds.
const cognito = {
  REGION: env("REACT_APP_COGNITO_REGION", "eu-central-1"),
  USER_POOL_ID: env("REACT_APP_USER_POOL_ID", "eu-central-1_4SZe6sbIm"),
  APP_CLIENT_ID: env(
    "REACT_APP_APP_CLIENT_ID",
    "1vcgfc6t65bb25muu2r5ivsdic"
  ),
  IDENTITY_POOL_ID: env(
    "REACT_APP_IDENTITY_POOL_ID",
    "eu-central-1:3a9a8638-f09c-46ca-8d4a-7406f1941c67"
  ),
};

// Local npm start and production builds use the same Cognito; only API URL differs.
const apiUrl = env(
  "REACT_APP_API_URL",
  process.env.NODE_ENV === "production"
    ? "https://api.flex.al"
    : "https://api.flex.al"
);

const config = {
  apiGateway: {
    REGION: env("REACT_APP_API_REGION", "eu-central-1"),
    URL: apiUrl,
  },
  cognito,
};

export default config;
